<template>
	<button class="favouriteBtn" @click="favourite()" :disabled="is_favouriting">
		<span :class="{'far': !favourited, 'fas': favourited}" class=" fa-star"></span>
	</button>
</template>
<script>
	import {userApi} from '../../api';
	export default {
		props: {
			post_id: {
				type: Number,
				required: true
			},
			favourited: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				is_favouriting: false,
			}
		},
		methods: {
			favourite() {
				let self = this;
				self.is_favouriting = true;
				userApi.favouriteArtwork({
					post_id: self.post_id
				}).then(response => {
					if(!response.data.error) {
						self.favourited = response.data.has_favourited;
						self.$root.$emit('on-favourite', {
							post_id: self.post_id,
							favourited: response.data.has_favourited
						});
						self.is_favouriting = false;
					}
				}, error => {
					console.log(error);
				});
			},
		}
	}
</script>